import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import module from "app/modules/well-integrity-planning/well-integrity-planning.module";

@Component({
  selector: 'app-preventive-maintainance',
  templateUrl: './index.page.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./index.page.scss']
})
export class IndexPage {

  tabs: any[] = [
    {
      name: "Preventive Maintenance",
      route: "pm",
    },
    {
      name: "Corrective Maintenance",
      route: "cm",
    },
    {
      name: "Retrievable Valve / Plug",
      route: "wrsv",
    },
    {
      name: "Annulus Pressure Record",
      route: "apr",
    },
    {
      name: "Ad-hoc Activity",
      route: "adhoc",
    },
    {
      name: "Additional Updates",
      route: "other-activity",
    },
    {
      name: "Well Integrity Remarks",
      route: "remarks",
    },
  ];

  constructor(public router: Router) {
  }

  onSelectedTab(selectedTab) {
    this.router.navigate([`/data-management/well-integrity-planning/${selectedTab}`]);
  }
}
